import { render, staticRenderFns } from "./StatisticsPanelContent.vue?vue&type=template&id=37587ec0"
import script from "./StatisticsPanelContent.vue?vue&type=script&lang=js"
export * from "./StatisticsPanelContent.vue?vue&type=script&lang=js"
import style0 from "./StatisticsPanelContent.vue?vue&type=style&index=0&id=37587ec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
